import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { connect } from 'react-redux';
import ArticlesSidebar from '../../components/ArticlesSidebar';
import FollowUs from '../../components/FollowUs';
import liveCourseBanner from '../../doc/img/live-course-banner.png';
import youtubeBanner from '../../doc/img/youtube-banner.jpg';
import {
  fetchAds,
  fetchArticleHomepage,
  fetchArticles,
  fetchArticlesProjekte,
  fetchArticlesWissen,
  fetchOffers,
  fetchOffersForPage,
  fetchOffersForPageCleanUp,
  updateOffersPageStartParam,
} from '../../store/actions';
import { fetchArticlesGesundeKommune } from '../../store/actions/gesundeKommuneActions';
import fetchSquirrelNews from '../../store/actions/getSquirrelNewsAction';
import CalendarWidget from '../CalendarWidget';

const SidebarArticles = ({
  fetchArticleHomepage,
  newsArticles = [],
  gtTippsArticles = [],
  fetchSquirrelNews,
  squirrelNewsArticles,
  fetchArticlesGesundeKommune,
  articlesGesundeKommune,
  fetchArticlesProjekte,
  articlesProjekte,
  fetchArticlesWissen,
  articlesWissen,
  fetchOffers,
  offers,
  categories,
  calendarContent,
}) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (categories.includes('angebote')) {
      fetchOffers({ limit: 4, locale: i18n.language });
    }

    if (categories.includes('bildung')) {
      fetchArticleHomepage({ limit: 4, locale: i18n.language });
    }

    if (
      categories.includes('gesundekommune') &&
      !articlesGesundeKommune.length
    ) {
      fetchArticlesGesundeKommune({ limit: 4, locale: i18n.language });
    }

    if (categories.includes('projekte') && !articlesProjekte.length) {
      fetchArticlesProjekte({ limit: 4, locale: i18n.language });
    }

    if (categories.includes('wissen') && !articlesWissen.length) {
      fetchArticlesWissen({ limit: 4, locale: i18n.language });
    }

    if (
      categories.includes('goodnews') &&
      !squirrelNewsArticles.squirrelNews.length
    ) {
      fetchSquirrelNews();
    }
  }, [i18n.language]);

  return (
    <>
      <a
        href="https://regiohealth.news/offer/neue-reiseangebote-und-retreats"
        rel="noopener noreferrer"
      >
        <img
          src="https://cms.regiohealth.net/uploads/Version1_03ef203331.png"
          alt="Neue Reiseangebote und Retreats für unsere TicketinhaberInnen"
        />
      </a>
      <div className="space-20" />
      <a
        href="https://www.youtube.com/@RegioHealthNetzwerk"
        rel="noopener noreferrer"
        target="_blank"
      >
        <img src={youtubeBanner} alt="Regio Health auf YouTube" />
      </a>
      <div className="space-20" />
      <a href="/offer/online-live">
        <img src={liveCourseBanner} alt="Online Live Kurse" />
      </a>
      {categories.includes('angebote') && (
        <ArticlesSidebar
          title={t('menu.offers')}
          contentData={offers}
          link="angebote"
        />
      )}
      {categories.includes('bildung') && (
        <ArticlesSidebar
          title={t('menu.education')}
          contentData={gtTippsArticles}
          link="bildung"
        />
      )}
      {categories.includes('gesundekommune') && (
        <ArticlesSidebar
          title={t('menu.healthyCommunity')}
          contentData={articlesGesundeKommune}
          link="gesundekommune"
        />
      )}
      {categories.includes('projekte') && (
        <ArticlesSidebar
          title={t('menu.projects')}
          contentData={articlesProjekte}
          link="projekte"
        />
      )}
      {categories.includes('goodnews') && (
        <ArticlesSidebar
          title={t('menu.goodNews')}
          contentData={newsArticles}
          squirrelNewsArticles={squirrelNewsArticles}
          link="goodnews"
        />
      )}
      {categories.includes('wissen') && (
        <ArticlesSidebar
          title={t('menu.knowledge')}
          contentData={articlesWissen}
          link="wissen"
        />
      )}
      <div className="space-30" />
      {/* Calendar Widget */}
      {calendarContent && <CalendarWidget calendarContent={calendarContent} />}
      <FollowUs
        title={t('followUs.title')}
        className="border-radious5 white_bg padding20 sm-mt30"
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allArticles: state.articles.articles,
    newsArticles: state.articles.articlesHomepage.newsArticles,
    latestOffers: state.offers.offersForPage,
    wissenArticles: state.articles.articlesHomepage.wissenArticles,
    gtTippsArticles: state.articles.articlesHomepage.gtTippsArticles,
    squirrelNewsArticles: state.squirrelNewsArticles,
    articlesGesundeKommune: state.articlesGesundeKommune.articles,
    articlesProjekte: state.articlesProjekte.articles,
    articlesWissen: state.articlesWissen.articles,
    offers: state.offers.offers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchArticles: ({ categories, start, limit }) =>
      dispatch(fetchArticles({ categories, start, limit })),
    fetchArticleHomepage: ({ locale }) =>
      dispatch(fetchArticleHomepage({ locale })),
    fetchOffersForPage: ({ start, limit }) =>
      dispatch(fetchOffersForPage({ start, limit })),
    fetchOffersForPageCleanUp: () => dispatch(fetchOffersForPageCleanUp()),
    updateOffersPageStartParam: () => dispatch(updateOffersPageStartParam()),
    fetchSquirrelNews: () => dispatch(fetchSquirrelNews()),
    fetchArticlesGesundeKommune: ({ categories, start, limit, locale }) =>
      dispatch(
        fetchArticlesGesundeKommune({
          categories,
          start,
          limit,
          locale,
        })
      ),
    fetchArticlesProjekte: ({ categories, start, limit, locale }) =>
      dispatch(fetchArticlesProjekte({ categories, start, limit, locale })),
    fetchArticlesWissen: ({ categories, start, limit, locale }) =>
      dispatch(fetchArticlesWissen({ categories, start, limit, locale })),
    fetchOffers: ({ categories, city, start, limit, locale }) =>
      dispatch(fetchOffers({ categories, city, start, limit, locale })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarArticles);
